import { render, staticRenderFns } from "./TTabList.vue?vue&type=template&id=9864e0e6&scoped=true&"
import script from "./TTabList.vue?vue&type=script&lang=js&"
export * from "./TTabList.vue?vue&type=script&lang=js&"
import style0 from "./TTabList.vue?vue&type=style&index=0&id=9864e0e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9864e0e6",
  null
  
)

/* custom blocks */
import block0 from "./TTabList.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports